export class FMGeneralRequestModel {
  generalFMRequestId: string;
  requestStatusName: string;
  requestStatusId: number;
  requestClassificationName: string;
  companyName: string;
  requestorName: string;
  requestCompeletionDate: string;
  requestId: number;
  requestNumber: string;
  issueListElectricalService : number[] ;
  issueListElevatorRepair: number[];
  issueListPlumbing: number[];
  issueListFurnitureRepair: number[];
  issueListHeating: number[];
  issueListCleaning: number[];
  issueMeetingRoom: number[];
  issueCommonArea: number[];

  electricalServicesIssueList: string [] ;
  elevatorRepairsIssueList   : string [] ;
    plumbingIssueList        : string [] ;
  furnitureRepairIssueList   : string [] ;
  heatingIssueList           : string [] ;
    cleaningIssueList        : string [] ;
      meetingRoomIssueList   : string [] ;
      commonAreaIssueList: string[];



  electricalServiceOther :string ;
  electricalServiceDetails :string ;
  elevatorRepairOther :string ;
  elevatorRepairDetails :string ;
  furnitureRepairOther :string ;
  furnitureRepairDetails :string ;
  heatingOther :string ;
  heatingDetails :string ;
  plumbingOther :string ;
  plumbingDetails :string ;
  meetingRoomOther :string ;
  meetingRoomDetails :string ;
  commonAreaOther :string ;
  commonAreaDetails :string ;
  cleaningOther :string ;
  cleaningDetails: string;
  CAFMRequestNumber: string;
  userCanFeedback: boolean;
}




// WEBPACK FOOTER //
// ./src/app/core/models/fm-general-request.ts